/** 缓存关键字 */
const WECOUPONS_SEARCH_KEY = 'WECOUPONS_SEARCH_KEY';

export function clearKeyStorage() {
  window.sessionStorage.removeItem(WECOUPONS_SEARCH_KEY);
}

export function setKeyStorage(key: string) {
  window.sessionStorage.setItem(WECOUPONS_SEARCH_KEY, key);
}

export function getKeyStorage() {
  return window.sessionStorage.getItem(WECOUPONS_SEARCH_KEY) || '';
}